import * as React from 'react';

import Filme from './filme.component';

const Evento = ({evento}) => {
  const { pais, filmes, data, hora, lugar } = evento;
  // Date input format: "2024-10-05"
  // Date output format: "05 de outubro de 2024"
  const textData = new Intl.DateTimeFormat('pt-PT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(data));
  return (
    <article id={pais} className="evento">
      <div className="left">
        <h1>{pais}</h1>
        <div className="when">
        <h3>{textData}</h3>
        <h2>{hora}</h2>
        </div>
        <div className="where">
        <h4>{lugar}</h4>
        </div>
      </div>
      <div className="right">
        {filmes.map((filme) => (
          <Filme {...filme}></Filme>
        ))}
      </div>
    </article>
  )
}

export default Evento
